import { render, staticRenderFns } from "./add-friends.vue?vue&type=template&id=567539d1&scoped=true"
import script from "./add-friends.vue?vue&type=script&lang=js"
export * from "./add-friends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567539d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('567539d1')) {
      api.createRecord('567539d1', component.options)
    } else {
      api.reload('567539d1', component.options)
    }
    module.hot.accept("./add-friends.vue?vue&type=template&id=567539d1&scoped=true", function () {
      api.rerender('567539d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/challenge-friends/views/add-friends.vue"
export default component.exports